import { render, staticRenderFns } from "./ApplicationTranslations.vue?vue&type=template&id=6631ba97&"
import script from "./ApplicationTranslations.vue?vue&type=script&lang=ts&"
export * from "./ApplicationTranslations.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports